import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-900 text-secondary-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-lg">
                <i className="ri-movie-2-line" />
              </span>
              <span className="text-xl font-black tracking-wide text-background-50">
                蜜月<span className="text-primary-400">TV</span>
              </span>
            </div>
            <p className="text-sm leading-relaxed text-secondary-300 max-w-md">
              蜜月TV 专注于提供最新影视剧资讯与精彩电影推荐，涵盖电视剧、电影、动漫等多样内容，
              帮助每一位影视爱好者轻松找到值得一看的作品。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50 mb-4">快速导航</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/category/tv" className="text-secondary-300 hover:text-primary-400 transition-colors">电视剧</Link></li>
              <li><Link to="/category/movie" className="text-secondary-300 hover:text-primary-400 transition-colors">电影</Link></li>
              <li><Link to="/category/anime" className="text-secondary-300 hover:text-primary-400 transition-colors">动漫</Link></li>
              <li><Link to="/news" className="text-secondary-300 hover:text-primary-400 transition-colors">影视资讯</Link></li>
              <li><Link to="/about" className="text-secondary-300 hover:text-primary-400 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50 mb-4">联系我们</h3>
            <ul className="space-y-2 text-sm text-secondary-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line" /> hello@miyuetv.example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line" /> 400-000-2024
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line" /> 中国 · 北京
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" aria-label="微博" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-100 hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-weibo-fill" />
              </a>
              <a href="#" aria-label="微信公众号" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-100 hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-wechat-fill" />
              </a>
              <a href="#" aria-label="视频号" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-100 hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-video-line" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-secondary-400">
          <p>© 2024 蜜月TV · 本站内容均为演示数据，仅供展示使用</p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="hover:text-primary-400 transition-colors">隐私政策</Link>
            <Link to="/about" className="hover:text-primary-400 transition-colors">版权声明</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}